import request from '@/utils/request';
//快速注册
export function regUser(params) {
  // 初始化
  return request({
    url: '/portal/psnregister/add',
    method: 'post',
    data: params,
  });
}

/**
 * 查询用户
 * 
 * @param {*} params 
 * @returns 
 */
export function queryUser() {
  // 初始化
  return request({
    url: '/portal/psnregister/query',
    method: 'post',
    data: '',
  });
}

//发送验证码
export function sendValidCode(params) {
  // 初始化
  return request({
    url: '/portal/login/sendemail',
    method: 'post',
    data: params,
  });
}

//修改后新密码
export function newPwd(params) {
  // 初始化
  return request({
    url: '/portal/login/forgetpwd',
    method: 'post',
    data: params,
  });
}

/**
 * changeOldpwd
 * 
 * {"oldpwd":"1234","newpwd":"q1q1q1","username":"测试"}
 * 
 * @param {*} params 
 * @returns 
 */
export function changeOldpwd(params) {
  // 初始化
  return request({
    url: '/portal/login/changepwd',
    method: 'post',
    data: params,
  });
}

// modify
// modifyUser
// {"name":"测试2",
// "username":"测试2",
// "id":"1222414311441",
// "sex":"女",
// "email":"1234@qq.com"}
export function modifyUser(params) {
  // 初始化
  return request({
    url: '/portal/psnregister/modify',
    method: 'post',
    data: params,
  });
}



// //修改密码
// export function editPwd() {
//   // 初始化
//   return request({
//     url: '/yigo/portal/psnregister/modify',
//     method: 'post',
//     data: {
//       name: '测试1',
//       username: '测试1',
//       id: '1222414311441',
//       sex: '女',
//       email: '1234@qq.com',
//     },
//   });
// }

//内部员工身份认证
export function authUser(params) {
  return request({
    url: '/portal/psnregister/auth',
    method: 'post',
    data: params,
  });
}
